{
  "Add Ons": "Add Ons",
  "Address search: {{errorMessage}}": "Address search: {{errorMessage}}",
  "Annually": "Annually",
  "Attract": "Attract",
  "Base": "Base",
  "Call Intelligence": "Call Intelligence",
  "Cancel": "Cancel",
  "Coordinate": "Coordinate",
  "Core": "Core",
  "Demo Features": "Demo Features",
  "Discount - Free Month": "Discount - Free Month",
  "Done": "Done",
  "Error searching address": "Error searching address",
  "Failed to update demo location customizations. Please try again": "Failed to update demo location customizations. Please try again",
  "Monthly": "Monthly",
  "One Time": "One Time",
  "Phones": "Phones",
  "Plus": "Plus",
  "Practice Analytics (Dental Only)": "Practice Analytics (Dental Only)",
  "Quarterly": "Quarterly",
  "Select Add Ons": "Select Add Ons",
  "Select Bundles": "Select Bundles",
  "Select Integration": "Select Integration",
  "Select or enter an address": "Select or enter an address",
  "Semi-annually": "Semi-annually",
  "Vertical": "Vertical",
  "Weave Insurance Verification": "Weave Insurance Verification",
  "billing": {
    "1331 W. Powell Way, Lehi, UT, 84043": "1331 W. Powell Way, Lehi, UT, 84043",
    "AMOUNT DUE": "AMOUNT DUE",
    "AMOUNT PAID": "AMOUNT PAID",
    "Add Payment Method": "Add Payment Method",
    "Become a Weave Expert": "Become a Weave Expert",
    "Bill To": "Bill To",
    "Billing Contact": "Billing Contact",
    "Billing questions? Please call <1>888-579-5668, Option. 2, Option. 3</1>": "Billing questions? Please call <1>888-579-5668, Option. 2, Option. 3</1>",
    "Cancel": "Cancel",
    "Customer ID": "Customer ID",
    "DESCRIPTION": "DESCRIPTION",
    "DUE DATE": "DUE DATE",
    "Date": "Date",
    "Due on receipt": "Due on receipt",
    "EXTENDED PRICE": "EXTENDED PRICE",
    "Error saving payment method.": "Error saving payment method.",
    "FROM ALL OF US AT WEAVE, <1>THANK YOU</1>": "FROM ALL OF US AT WEAVE, <1>THANK YOU</1>",
    "First and Last name": "First and Last name",
    "First name and last name is required": "First name and last name is required",
    "ITEM #": "ITEM #",
    "If this amount exceeds zero dollars, please follow this link to update the payment information on file": "If this amount exceeds zero dollars, please follow this link to update the payment information on file",
    "Invoice": "Invoice",
    "Loading...": "Loading...",
    "Make Primary Payment Method": "Make Primary Payment Method",
    "Need Training?": "Need Training?",
    "PAYMENT TERMS": "PAYMENT TERMS",
    "PLEASE DO NOT MAKE PAYMENT BY CHECK. AMOUNTS BELOW ARE STATED IN {{currency}}.": "PLEASE DO NOT MAKE PAYMENT BY CHECK. AMOUNTS BELOW ARE STATED IN {{currency}}.",
    "PRODUCT": "PRODUCT",
    "Payment method added successfully.": "Payment method added successfully.",
    "QTY": "QTY",
    "Save": "Save",
    "Submitting, please wait...": "Submitting, please wait...",
    "TOTAL": "TOTAL",
    "UNIT PRICE": "UNIT PRICE",
    "WEAVE COMMUNICATIONS, INC.": "WEAVE COMMUNICATIONS, INC.",
    "Your total amount due is {{amount}}": "Your total amount due is {{amount}}",
    "at <2>www.weavehelp.com</2>": "at <2>www.weavehelp.com</2>",
    "or email us at": "or email us at"
  },
  "phone-input-page": {
    "Add Your Business Phone Number to Continue": "Add Your Business Phone Number to Continue",
    "BUSINESS PHONE NUMBER": "BUSINESS PHONE NUMBER",
    "Continue": "Continue",
    "This number will be used to assign a Weave number in your area.": "This number will be used to assign a Weave number in your area."
  },
  "quote": {
    "*Annual contract discounts applied": "*Annual contract discounts applied",
    "*Annual discounts applied": "*Annual discounts applied",
    "*Monthly contract discounts applied": "*Monthly contract discounts applied",
    "*Monthly discounts applied": "*Monthly discounts applied",
    "Accept Quote": "Accept Quote",
    "Additional Fee (per transaction) for Surcharging": "Additional Fee (per transaction) for Surcharging",
    "Address Validation": "Address Validation",
    "Amount": "Amount",
    "An error occurred when declining quotes.": "An error occurred when declining quotes.",
    "An error occurred when retrieving quote data.": "An error occurred when retrieving quote data.",
    "Annual": "Annual",
    "Annual Discount": "Annual Discount",
    "Apt, suite, etc. (optional)": "Apt, suite, etc. (optional)",
    "Are you sure?": "Are you sure?",
    "Back": "Back",
    "Bundle Discount": "Bundle Discount",
    "Business Name": "Business Name",
    "Charges": "Charges",
    "City": "City",
    "Client Information": "Client Information",
    "Contact Sales Rep": "Contact Sales Rep",
    "Continue": "Continue",
    "Continue to Signature": "Continue to Signature",
    "Country": "Country",
    "Decline all quotes": "Decline all quotes",
    "Declining Quotes. Please wait...": "Declining Quotes. Please wait...",
    "Decreased by": "Decreased by",
    "Demo": "Demo",
    "Discount": "Discount",
    "Due Today": "Due Today",
    "Due on Install": "Due on Install",
    "Edit": "Edit",
    "Edit Address": "Edit Address",
    "Electronic Signature": "Electronic Signature",
    "Error fetching data": "Error fetching data",
    "Exp": "Exp",
    "Exp: {{date}}": "Exp: {{date}}",
    "Federal, state, and local taxes and surcharges may apply.": "Federal, state, and local taxes and surcharges may apply.",
    "First and Last Name": "First and Last Name",
    "First name and last name Required": "First name and last name Required",
    "First, let's review your business information below": "First, let's review your business information below",
    "Got It": "Got It",
    "I agree Billing will begin on the completion of my phone install onboarding call and I understand that phone number porting and text functionality can take additional time and require I update personal company disclosures.": "I agree Billing will begin on the completion of my phone install onboarding call and I understand that phone number porting and text functionality can take additional time and require I update personal company disclosures.",
    "I agree to Weave's <2>Terms of Service.</2>": "I agree to Weave's <2>Terms of Service.</2>",
    "I agree to the third-party installer’s <2>Terms of Service.</2>": "I agree to the third-party installer’s <2>Terms of Service.</2>",
    "I understand and agree that I am responsible for paying all recurring charges and other applicable fees for the entire Term.": "I understand and agree that I am responsible for paying all recurring charges and other applicable fees for the entire Term.",
    "Included": "Included",
    "Increased by": "Increased by",
    "Installation Site Details": "Installation Site Details",
    "Installation of up to 15 Weave devices (Phones or CC Terminals) and up to 4 new cable runs": "Installation of up to 15 Weave devices (Phones or CC Terminals) and up to 4 new cable runs",
    "Installer's Terms and Conditions": "Installer's Terms and Conditions",
    "Item": "Item",
    "List Price": "List Price",
    "Looks like this quote has already been signed.": "Looks like this quote has already been signed.",
    "Main Phone Number": "Main Phone Number",
    "Make default": "Make default",
    "Month": "Month",
    "Monthly": "Monthly",
    "Months": "Months",
    "Net Total": "Net Total",
    "New Price": "New Price",
    "New Quoted Price": "New Quoted Price",
    "No valid quote data found.": "No valid quote data found.",
    "Non-Standard Transaction": "Non-Standard Transaction",
    "Non-Terminal transactions like Text-to-Pay, Online Bill Pay, Mobile Tap-to-Pay, and others.": "Non-Terminal transactions like Text-to-Pay, Online Bill Pay, Mobile Tap-to-Pay, and others.",
    "Notes": "Notes",
    "Okay": "Okay",
    "One Time": "One Time",
    "One Time Charges": "One Time Charges",
    "Onsite Installation Charge": "Onsite Installation Charge",
    "Outstanding Balance": "Outstanding Balance",
    "Partner Quote": "Partner Quote",
    "Payment Information": "Payment Information",
    "Payments Processing Rates": "Payments Processing Rates",
    "Payments taken on an encrypted terminal": "Payments taken on an encrypted terminal",
    "Plan": "Plan",
    "Please Verify {{cardTitle}}": "Please Verify {{cardTitle}}",
    "Please confirm you want to use this address without validation, or edit your address.": "Please confirm you want to use this address without validation, or edit your address.",
    "Please fill out the necessary information below": "Please fill out the necessary information below",
    "Please see your summary charges below.": "Please see your summary charges below.",
    "Please try again": "Please try again",
    "Postal": "Postal",
    "Powered by 2CP Services": "Powered by 2CP Services",
    "Previous Price": "Previous Price",
    "Previous Quoted Price": "Previous Quoted Price",
    "Previous Step": "Previous Step",
    "Price": "Price",
    "Price Change": "Price Change",
    "Product": "Product",
    "Proposed Flat Rate Pricing": "Proposed Flat Rate Pricing",
    "Quantity": "Quantity",
    "Quote Amendments": "Quote Amendments",
    "Quote Details": "Quote Details",
    "Quote Id: {{id}}": "Quote Id: {{id}}",
    "Quote Number: {{number}}": "Quote Number: {{number}}",
    "Quote Summary": "Quote Summary",
    "Recurring Charges": "Recurring Charges",
    "Refresh": "Refresh",
    "Retrieving Quote Data...": "Retrieving Quote Data...",
    "Review the disclaimers and sign your quote below.": "Review the disclaimers and sign your quote below.",
    "See Below": "See Below",
    "See below for the breakdown of your one time charges": "See below for the breakdown of your one time charges",
    "See below for the breakdown of your proposed flat rate pricing": "See below for the breakdown of your proposed flat rate pricing",
    "See below for the breakdown of your {{chargeType}}": "See below for the breakdown of your {{chargeType}}",
    "See below for the breakdown of your {{subscriptionPeriod}} recurring charges": "See below for the breakdown of your {{subscriptionPeriod}} recurring charges",
    "Select Quote": "Select Quote",
    "Shipping Address": "Shipping Address",
    "Shipping Information": "Shipping Information",
    "Sign Quote": "Sign Quote",
    "Signed": "Signed",
    "Something not right?": "Something not right?",
    "Something went wrong": "Something went wrong",
    "Something went wrong. Please try again.": "Something went wrong. Please try again.",
    "Standard Transaction": "Standard Transaction",
    "Starting 60 days after payments activation, you will be charged a fee up to $50 for each month in which you do not process at least $10,000 in payments volume.": "Starting 60 days after payments activation, you will be charged a fee up to $50 for each month in which you do not process at least $10,000 in payments volume.",
    "State": "State",
    "Street Address": "Street Address",
    "Submit Payment Information": "Submit Payment Information",
    "Submitting data. Please wait...": "Submitting data. Please wait...",
    "Subtotal": "Subtotal",
    "Success!": "Success!",
    "Temporary Discounts": "Temporary Discounts",
    "Term": "Term",
    "The Term of this Quote is one year, beginning on the date installation is complete.": "The Term of this Quote is one year, beginning on the date installation is complete.",
    "Third-Party Partner Quotes for Onsite Installation": "Third-Party Partner Quotes for Onsite Installation",
    "This fee will be added to your transaction rates for the use of the surcharging feature.": "This fee will be added to your transaction rates for the use of the surcharging feature.",
    "To ensure accurate delivery, consider using the suggested address below or editing your entered address.": "To ensure accurate delivery, consider using the suggested address below or editing your entered address.",
    "Total": "Total",
    "Type": "Type",
    "Unable to Find Address": "Unable to Find Address",
    "Unit Price": "Unit Price",
    "Unknown": "Unknown",
    "Use Suggested Address": "Use Suggested Address",
    "Use address without validation": "Use address without validation",
    "Use address without verification": "Use address without verification",
    "Use selected address": "Use selected address",
    "Verified": "Verified",
    "We suggest:": "We suggest:",
    "We were unable to find a match for the address entered. Please enter a verified address to continue.": "We were unable to find a match for the address entered. Please enter a verified address to continue.",
    "We were unable to find a verified match for the address entered. Edit the address or confirm and proceed with the entered unverified address.": "We were unable to find a verified match for the address entered. Edit the address or confirm and proceed with the entered unverified address.",
    "Weave Signed Agreement": "Weave Signed Agreement",
    "You agree and acknowledge that by executing a Weave Quote for a Satellite Location (defined as a Location contracted to use the Weave Products and Services for six (6) days a month or less) you will adhere to Weave's usage restrictions. Weave reserves the right to monitor such usage. In the event that your usage exceeds that of a Satellite Location, Weave reserves the right to upgrade your subscription to the appropriate Weave Products and Services based on your usage and charge any corresponding fees.": "You agree and acknowledge that by executing a Weave Quote for a Satellite Location (defined as a Location contracted to use the Weave Products and Services for six (6) days a month or less) you will adhere to Weave's usage restrictions. Weave reserves the right to monitor such usage. In the event that your usage exceeds that of a Satellite Location, Weave reserves the right to upgrade your subscription to the appropriate Weave Products and Services based on your usage and charge any corresponding fees.",
    "You entered": "You entered",
    "You entered:": "You entered:",
    "You have signed up for a Weave Feature that includes call recording. You acknowledge that all calls may be recorded automatically by activating the Feature and you understand that it is your responsibility to comply with all laws and regulations related to call recording.": "You have signed up for a Weave Feature that includes call recording. You acknowledge that all calls may be recorded automatically by activating the Feature and you understand that it is your responsibility to comply with all laws and regulations related to call recording.",
    "You're one step closer to joining Weave!": "You're one step closer to joining Weave!",
    "Your sales rep has made changes to the quote. Please contact your sales rep to receive the updated version.": "Your sales rep has made changes to the quote. Please contact your sales rep to receive the updated version.",
    "Your savings": "Your savings",
    "acceptQuoteSubTitle": {
      "MultipleQuote": "Please review all quotes and accept the partner you wish to move forward with for installation services.",
      "SingleQuote": "Please review and accept if you wish to move forward with this partner for installation services."
    },
    "additionalServiceChargeFooterNote": "Additional services may be contracted with the third-party installer directly, including additional cable runs for {{cableRunUnitPrice}} each and additional device Installation (phone or cc terminal) for {{deviceInstallUnitPrice}} each.",
    "declineAllQuoteModalMessage": "Are you sure you would like to Decline all quotes? You will be responsible for install of all Weave devices and network readiness.",
    "e.g. \"Ste 42\", \"Apt 42\" - not \"Apt42\" or \"Ste42\".": "e.g. \"Ste 42\", \"Apt 42\" - not \"Apt42\" or \"Ste42\".",
    "incorrectQuoteModalMessage": "If any information regarding your quote is incorrect, contact your sales rep. Your sales rep may send you an updated quote.",
    "redirectToPaymentModalMessage": "Looks like this quote has already been signed. Click \"Continue\" if you would like to submit payment information.",
    "successMessage": {
      "declinedAllITInstallerQuotes": "All quotes have been declined. Please close this window.",
      "signedITInstallerQuote": "We’ll send you an email with a copy of your quote for your records. You will be contacted in the next few days to schedule your installation."
    },
    "summaryPanelFooterNote": "*Federal, state, and local taxes and surcharges may apply and will be added to the price of your Weave services.",
    "thirdPartyBillAgreement": "I understand that only the services set forth in the quote are included in the price. Any additional services will be contracted for and billed directly with the third-party installer.",
    "thirdPartyPaymentAgreement": "I understand that payment for the services will be made directly to the third-party installer and will be due at completion of the services. I understand Weave is not a party to the transaction, and the amounts owed are not included in any quotes from or payments made to Weave.",
    "thirdPartyServiceAgreement": "I understand that the services will be performed by the third-party installer and not by Weave. Weave is not responsible for ensuring the completeness or adequacy of the services rendered.",
    "unit": "unit",
    "{{amount}} discount applied": "{{amount}} discount applied",
    "{{amount}} discount applied, including temporary discounts": "{{amount}} discount applied, including temporary discounts",
    "{{discountAmount}} discount applied": "{{discountAmount}} discount applied",
    "{{discountAmount}} discount applied, including temporary discounts": "{{discountAmount}} discount applied, including temporary discounts",
    "{{percent}}% + {{additionalFees}} per transaction": "{{percent}}% + {{additionalFees}} per transaction"
  },
  "quote-loader": {
    "72% of patients prefer appointment reminders via text—set yours up today!": "72% of patients prefer appointment reminders via text—set yours up today!",
    "79% of patients prefer texting: Start sending texts instantly with Weave.": "79% of patients prefer texting: Start sending texts instantly with Weave.",
    "79% of patients prefer to communicate via text. Send your first text in just a moment.": "79% of patients prefer to communicate via text. Send your first text in just a moment.",
    "83% of offices that use Weave Payments get paid faster. Weave Payments is included in your bundle.": "83% of offices that use Weave Payments get paid faster. Weave Payments is included in your bundle.",
    "83% of offices using Weave Payments collect payments faster.": "83% of offices using Weave Payments collect payments faster.",
    "9 in 10 consumers want businesses to communicate via text.": "9 in 10 consumers want businesses to communicate via text.",
    "A Vet Clinic saved 2 hours daily by switching to Weave Texting and Appointment Reminders.": "A Vet Clinic saved 2 hours daily by switching to Weave Texting and Appointment Reminders.",
    "A Vet Hospital is paying 50% less per month by switching to Weave.": "A Vet Hospital is paying 50% less per month by switching to Weave.",
    "A Weave Dental customer reduced staffing costs by nearly $50,000 annually.": "A Weave Dental customer reduced staffing costs by nearly $50,000 annually.",
    "A Weave Dental customer saves approximately $300 a month just by switching to Weave.": "A Weave Dental customer saves approximately $300 a month just by switching to Weave.",
    "A Weave customer can save 50% monthly compared to their previous software.": "A Weave customer can save 50% monthly compared to their previous software.",
    "At Weave, 93% of support issues are solved on first contact.": "At Weave, 93% of support issues are solved on first contact.",
    "Automated rescheduling texts help you retain patients and fill your schedule.": "Automated rescheduling texts help you retain patients and fill your schedule.",
    "Boost office efficiency by 30% with Weave's texting and text-to-pay features.": "Boost office efficiency by 30% with Weave's texting and text-to-pay features.",
    "Confirm over 50% of patient appointments via text with Weave.": "Confirm over 50% of patient appointments via text with Weave.",
    "Cue the anticipation.": "Cue the anticipation.",
    "Decrease no-shows by more than 20% by using Weave automated appointment reminders.": "Decrease no-shows by more than 20% by using Weave automated appointment reminders.",
    "Decrease no-shows by over 20% with automated text reminders.": "Decrease no-shows by over 20% with automated text reminders.",
    "Done": "Done",
    "Get paid faster: Weave Payments is included in your bundle.": "Get paid faster: Weave Payments is included in your bundle.",
    "Increase office efficiency by 30% with Weave texting and text to pay.": "Increase office efficiency by 30% with Weave texting and text to pay.",
    "Just a second, we're finishing a few things up": "Just a second, we're finishing a few things up",
    "Open in Browser": "Open in Browser",
    "Please keep this page open while we set up Weave.": "Please keep this page open while we set up Weave.",
    "Save 2+ hours a day by using Weave Texting and Appointment Reminders.": "Save 2+ hours a day by using Weave Texting and Appointment Reminders.",
    "Save over 2 hours daily with Weave Texting and Appointment Reminders.": "Save over 2 hours daily with Weave Texting and Appointment Reminders.",
    "Save staff over 15 hours per week by confirming appointments via text.": "Save staff over 15 hours per week by confirming appointments via text.",
    "Scan the QR code or visit getweave.com/app on your device": "Scan the QR code or visit getweave.com/app on your device",
    "This may take up to a minute. Thank you for your patience.": "This may take up to a minute. Thank you for your patience.",
    "Weave Desktop App": "Weave Desktop App",
    "Weave Mobile App": "Weave Mobile App",
    "While you wait, why don't you download the Weave apps?": "While you wait, why don't you download the Weave apps?"
  },
  "quote-signup-result": {
    "Looks like something isn't working on our side. Try refreshing the page - if that doesn't work, let your sales rep know and we'll get it fixed!": "Looks like something isn't working on our side. Try refreshing the page - if that doesn't work, let your sales rep know and we'll get it fixed!",
    "Oops! Something went wrong": "Oops! Something went wrong",
    "Thank you for signing up with Weave!": "Thank you for signing up with Weave!",
    "Thanks for being a part of Weave! We'll send an email with a copy of your quote for your records.": "Thanks for being a part of Weave! We'll send an email with a copy of your quote for your records.",
    "We'll send you an email with a copy of your quote for your records. Your sales rep will contact you shortly regarding your next steps!": "We'll send you an email with a copy of your quote for your records. Your sales rep will contact you shortly regarding your next steps!",
    "Whoops! We encountered an issue...": "Whoops! We encountered an issue...",
    "Your Weave Onboarding Manager will reach out to you shortly to help set up your account.": "Your Weave Onboarding Manager will reach out to you shortly to help set up your account."
  },
  "{{itemName}} - {{count}} Free Month_one": "{{itemName}} - {{count}} Free Month",
  "{{itemName}} - {{count}} Free Month_other": "{{itemName}} - {{count}} Free Months"
}
